export default __webpack_public_path__ + "static/media/Brow_6_C2.fb3502aa.svg";